function CheckAllLocationTypes() {
    var children = $('#LocationInformationCheckBoxes .LocationInformationInputSection input:checked').length;
    if (children == 4) {
        $('#LocationInformationCheckBoxes .LocationInformationInputSection :checkbox').attr('checked', false);
        $('#LocationInformationCheckBoxes .LocationInformationHeadings :checkbox').attr('checked', true);
    }
    if ($('#LocationInformationCheckBoxes .LocationInformationHeadings input:checkbox').attr('checked')) {
        $('#LocationInformationCheckBoxes .LocationInformationInputSection :checkbox').attr('checked', false);
    }
    if (children == 0) {
        $('#LocationInformationCheckBoxes .LocationInformationHeadings input:checkbox').attr('checked', true);
        $("#chkAllCompanies").prop('checked', true);
    }
    if ($("#chkAllCompanies").prop('checked')) {
            $('#LocationInformationCheckBoxes .LocationInformationInputSection :checkbox').attr('checked', false);
    }
}

function CheckLocationType() {
    $('#LocationInformationCheckBoxes .LocationInformationHeadings :checkbox').attr('checked', $('#LocationInformationCheckBoxes .LocationInformationInputSection input:checked').length == 4 ? true : false);
    CheckAllLocationTypes();
}

function StockExchangeSelect(e) {
    if ($(e).is(':checked')) {
        $(e).prop('checked', true);
    } else {
        $(e).prop('checked', false);
    }
    UpdateStockExchangeSelection();
};

function UpdateStockExchangeSelection() {
    var $stockExchgSelections = $('#frmLocationInformation input#SerializedStockExchange:hidden');
    $stockExchgSelections.val('');

    var stockExchgSelections = new Array();
    $('.StockExchangeSelection input:checkbox:checked').each(function (i, o) {
        stockExchgSelections.push($(o).attr('id') + ':' + $(o).val());
    });
    $stockExchgSelections.val(stockExchgSelections.join('~'));
};

